'use strict';

/* global $ */

import { breakpoints } from 'settings'

function ShowMore (options) {
    let opt = $.extend({
        contentSelector: '.js-info-more__content',
        titleSelector: '.js-info-more__link',
        blockSelector: '.js-info-more',
        itemSelector: '.js-info-more__block',
    }, options);

    function InitAct (block) {
        let items = $(block).find(opt.itemSelector);
        console.log(items);
        $(items).each(function() {
            ActItem(this); 
        });
    }

    function ActItem (item) {
        let title = $(item).find(opt.titleSelector);
        let content = $(item).find(opt.contentSelector);

        $(title).on('click', function() {

            if (this.classList.contains('active')) {
                CloseAll();
                this.classList.remove('active');
            } else {
                CloseAll();
                this.classList.add('active');
                $(content).slideToggle();
            }
        });
    }

    function CloseAll() {
        let titles = $(opt.blockSelector).find(opt.titleSelector);
        let contents = $(opt.blockSelector).find(opt.contentSelector);
        $(titles).removeClass('active');
        $(contents).slideUp();
    }

    $(opt.blockSelector).each(function() {
        InitAct(this); 
    });
}


export {
    ShowMore
};